var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticClass:"amount-alignment input-align-right",attrs:{"value":_vm.amount,"label":_vm.label,"dense":"","prefix":_vm.prefix},on:{"keydown":function($event){return _vm.onKeydown($event)},"focus":function($event){return _vm.onGetFocus($event)},"change":_vm.callChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }